"use client";
import e, { useState as x, useMemo as f, useEffect as E } from "react";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import $ from "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import A from "./index.es160.js";
import B from "./index.es161.js";
const M = ({
  displayMode: t,
  indicator: r,
  regionsData: n,
  year: m,
  units: s,
  valuesByYear: v,
  tableChartData: l,
  indicatorDistribution: p,
  isDownload: i,
  onChartChange: u
}) => {
  const [o, C] = x({
    distribution: void 0,
    "all-years": void 0,
    "single-year": void 0,
    table: void 0
  }), y = f(
    () => t === "distribution" ? "distribution" : "values",
    [t]
  ), c = () => (a) => {
    if (a) {
      const b = { ...o };
      b[t] = a, C(b);
    }
  }, d = f(() => o[t === "table" ? "all-years" : t], [y, o]);
  E(() => {
    u && u(d);
  }, [d]);
  const h = i ? "-download" : "", I = t === "table" ? void 0 : !0, g = i ? r.title : void 0;
  return /* @__PURE__ */ e.createElement("div", { "aria-hidden": I }, t === "distribution" && p && /* @__PURE__ */ e.createElement(
    A,
    {
      keyContext: `indicator-details-distribution-${r.indicatorApiId}${h}`,
      distributionData: p,
      regionsData: n,
      year: m || "",
      title: g,
      onChartChange: c()
    }
  ), (t === "all-years" || t === "single-year") && /* @__PURE__ */ e.createElement(
    B,
    {
      keyContext: `indicator-details-values-${r.indicatorApiId}${h}`,
      indicator: r,
      units: s,
      regionYearValues: v,
      regionsData: n,
      year: t !== "all-years" && m || null,
      unitsName: s === "Absolute" ? r.absoluteUnitsOverride : r.proportionalUnitsOverride,
      isDownload: i,
      onChartChange: c()
    }
  ), t === "table" && l && /* @__PURE__ */ e.createElement(
    $,
    {
      chartdata: l,
      isDecimal: !0,
      parentId: `details-table-${r.indicatorApiId}`,
      caption: r.title
    }
  ));
};
export {
  M as default
};
//# sourceMappingURL=index.es86.js.map
